const RecipeModelFactory = ({
  id,
  userID,
  hash,
  content,
  createdAt,
  likes,
  userName,
}) => {
  return {
    id,
    userID,
    hash,
    content,
    createdAt,
    likes: likes || 0,
    userName: userName || '',
  };
};

export default RecipeModelFactory;
